//@flow
import React from "react";
import Svg, { Path } from "react-native-svg";

type Props = {
  size: number,
  color: string
};

export default function Qtum({ size, color }: Props) {
  return (
    <Svg viewBox="0 0 16 16" width={size} height={size}>
      <Path
        fill={color}
        d="M13.399 11.881L16 14.118l-.877 1.02-2.596-2.232-2.967 2.16-4.578-.06-3.593-2.625L0 7.97l1.36-4.266L5.09 1h4.5l3.633 2.677 1.396 4.3-1.22 3.904zM5.527 2.345l-3.02 2.19-1.096 3.438 1.128 3.582 2.89 2.11 3.7.05 2.748-2 .246-.263 1.085-3.467-1.13-3.482-2.93-2.158h-3.62zm7.345 9.083L16 14.118l-.877 1.02-3.128-2.69.877-1.02zM4.34 9.978l-.493.816h2.072l-.494-.815-.542-.89-.543.889zm1.12-2.53l1.115 1.833 1.735 2.858H1.462l.617-1.02 1.112-1.84 1.695-2.772.573.941zm4.462 1.568l-1.075 1.773h2.15L9.922 9.016zm3.464 3.118H6.458l3.464-5.713 3.464 5.713zm-6.025-.505l.875-.502 1.692 2.948-1.167.67L7.358 12.3 5.96 14.36l-1.113-.755 1.712-2.521.803.545zm2.984-6.018l.447-.704H8.83l.447.705.533.844.535-.845zM9.24 8.073L8.14 6.33 6.386 3.56h6.85l-.654 1.033-1.1 1.738-1.675 2.64-.567-.9zm-3.854-2.42l.47-.746H3.81l.47.745.553.874.554-.874zm-1.124 2.49L3.142 6.37 1.371 3.56h6.922l-.65 1.032-1.121 1.779L4.829 9.04l-.567-.897zm4.484-6.69l1.1.776-1.688 2.393-1.1-.776 1.688-2.392zm1.1.776L8.157 4.622l-1.1-.776 1.688-2.392 1.1.775zM4.82 1.785l1.153-.692 1.678 2.795-1.154.692L4.82 1.785zm1.153-.692l1.678 2.795-1.154.692L4.82 1.785l1.153-.692zM.706 8.644V7.3h13.212v1.345H.706zm0-1.345h13.212v1.345H.706V7.3z"
      />
    </Svg>
  );
}
